import Missions from '../components/Missions/Missions';

const MissionsPage = () => (
  <Missions />
);

export default MissionsPage;
